import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
// import { LOGIN_URL } from '../utils/commonUtil';

// 患者一覧画面
import PatientList from '../containers/PatientList';
import DoctorList from '../containers/DoctorList';
import UserDetails from '../containers/UserDetails';
import HostpitalList from '../containers/HospitalList';
import InquiryList from '../containers/InquiryList';
import InquiryDetails from '../containers/InquiryDetails';
import Menu from '../containers/Menu';

export default class Routes extends React.Component {

  render() {
    return (
      <Switch>
        {/* メニュー画面 */}
        <Route path="/management_admin_menu" component={Menu} />
        {/* 患者リスト */}
        <Route path="/patients" component={PatientList} />
        {/* 患者詳細 */}
        <Route path="/patient/:userId" component={UserDetails} />
        {/* 医師リスト */}
        <Route path="/doctors" component={DoctorList} />
        {/* 医師詳細 */}
        <Route path="/doctor/:userId/:hospitalId" component={UserDetails} />
        {/* 医療機関リスト */}
        <Route path="/hospitals" component={HostpitalList} />
        {/* 医療機関詳細 */}
        <Route path="/hospital/:userId" component={UserDetails} />
        {/* 問い合わせ詳細 */}
        <Route path="/inquiries/details/:inquiryId" component={InquiryDetails} />
        {/* 問い合わせリスト */}
        <Route path="/inquiries" component={InquiryList} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Routes.tsx